import { render, staticRenderFns } from "./InstSuggest.vue?vue&type=template&id=815fabf6&scoped=true&"
import script from "./InstSuggest.vue?vue&type=script&lang=js&"
export * from "./InstSuggest.vue?vue&type=script&lang=js&"
import style0 from "./InstSuggest.vue?vue&type=style&index=0&id=815fabf6&lang=scss&scoped=true&"
import style1 from "./InstSuggest.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815fabf6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('815fabf6')) {
      api.createRecord('815fabf6', component.options)
    } else {
      api.reload('815fabf6', component.options)
    }
    module.hot.accept("./InstSuggest.vue?vue&type=template&id=815fabf6&scoped=true&", function () {
      api.rerender('815fabf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SuggestInput/InstSuggest.vue"
export default component.exports